<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-chart autoresize :option="chartOptions" style="height: 122px"></v-chart>
  </v-container>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])
// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  name: 'WorkStateChart',
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      chartUnit: 'kW'
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    chartOptions() {
      return {
        series: [
          {
            radius: '150%',
            center: ['50%', '80%'],
            type: 'gauge',
            startAngle: 180,
            endAngle: -0,
            min: this.min,
            max: this.max,
            itemStyle: {
              color: this.color
            },
            progress: {
              show: true,
              width: 30
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 30,
                color: [
                  [1, '#6B6B7A']
                ]
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 25,
              height: '-35%',
              offsetCenter: [0, '-40%'],
              fontWeight: 'bolder',
              formatter: function (value) {
                return '{value|' + value.toFixed(0) + '}\n{unit|' + 'kW' + '}'
              },
              rich: {
                value: {
                  fontSize: '25px',
                  fontWeight: 'bolder',
                  color: 'auto'
                },
                unit: {
                  fontSize: '12px',
                  color: '#B5BDC7',
                  padding: [0, 0, 0, 0]
                }
              }
            },
            data: [{
              value: this.value
            }]
          }
        ]
      }
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style scoped>

</style>
